var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent() && _vm.providers.length)?_c('div',{staticClass:"sidebar-ranking"},[_c('h2',{staticClass:"sidebar-ranking__title"},[_vm._v(" "+_vm._s(_vm.$t('Best VPN Offers'))+" ")]),_vm._l((_vm.topThreePartners),function(partner,index){return _c('SidebarRankingCard',_vm._b({key:index,attrs:{"partner":partner,"index":index}},'SidebarRankingCard',{
            ..._vm.styleProps,
        },false))})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }